import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { fetchFeaturedListings } from '../../ducks/featuredListings.duck';
export const ASSET_NAME = 'landing-page';

export const LANDING_FEATURED_LISTINGS_PARENT_PAGE = 'throttlex-landing-page';
export const LANDING_FEATURED_LISTINGS_SECTION_ID = 'throttlex-home-live-listings';

export const LANDING_CATEGORY_FEATURED_SECTION_IDS = {
  jetSki: 'throttlex-home-featured-jet-ski',
  boat: 'throttlex-home-featured-boat',
  utv: 'throttlex-home-featured-utv',
};

const landingCategoryFeaturedSections = [
  {
    sectionId: LANDING_CATEGORY_FEATURED_SECTION_IDS.jetSki,
    sectionType: 'listings',
    listingSelection: 'queryString',
    listingSearchQuery: { keywords: 'jet ski' },
  },
  {
    sectionId: LANDING_CATEGORY_FEATURED_SECTION_IDS.boat,
    sectionType: 'listings',
    listingSelection: 'queryString',
    listingSearchQuery: { keywords: 'boat' },
  },
  {
    sectionId: LANDING_CATEGORY_FEATURED_SECTION_IDS.utv,
    sectionType: 'listings',
    listingSelection: 'queryString',
    listingSearchQuery: { keywords: 'utv' },
  },
];

const landingFeaturedListingsSection = {
  sectionId: LANDING_FEATURED_LISTINGS_SECTION_ID,
  sectionType: 'listings',
  listingSelection: 'newest',
};

export const loadData = (params, search) => dispatch => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };

  const listingImageConfig = {
    aspectWidth: 1,
    aspectHeight: 1,
    variantPrefix: 'listing-card',
  };

  return Promise.all([
    dispatch(fetchPageAssets(pageAsset, true)),
    dispatch(
      fetchFeaturedListings({
        parentPage: LANDING_FEATURED_LISTINGS_PARENT_PAGE,
        sectionId: LANDING_FEATURED_LISTINGS_SECTION_ID,
        listingImageConfig,
        allSections: [landingFeaturedListingsSection],
      })
    ),
    ...landingCategoryFeaturedSections.map(section =>
      dispatch(
        fetchFeaturedListings({
          parentPage: LANDING_FEATURED_LISTINGS_PARENT_PAGE,
          sectionId: section.sectionId,
          listingImageConfig,
          allSections: landingCategoryFeaturedSections,
        })
      )
    ),
  ]);
};
